const genericErrorMessage = 'Something went wrong, please try again. Contact admin if this error persists.';
const trialExpired = 'You have reached the maximum limit of 2 pages in the free plan. Subscribe to 4t4 premium plan to publish unlimited pages';

module.exports = {
	genericErrorMessage,
	trialExpired,
};
